import MainTechnicalDataContainer from './main-technical-data-container';

export default MainTechnicalDataContainer;